module.exports = __webpack_public_path__ + "assets/img/template_logo.e8c141a0.svg";